import { useState } from "react";
import { useChat } from "../../Context/ChatContext";
import { useAuth } from "../../Context/AuthContext";
import { Paperclip, Globe, Zap, MoreHorizontal, ArrowUp } from "react-feather";

const IntellachatInput = () => {
  const [currentText, setCurrentText] = useState("");
  const { handleSubmitMessage } = useChat();
  const { currentProfile } = useAuth();
  const isDev = currentProfile?.privileges === 'dev';

  const handleButtonClick = () => {
    if (currentText.trim() !== "") {
      handleSubmitMessage(currentText);
      setCurrentText("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleButtonClick();
    }
  };

  return (
    <div className="w-full">
      {/* Input Container */}
      <div className="bg-dark-card border border-dark-border rounded-2xl p-4 shadow-lg">
        {/* Text Input */}
        <div className="mb-3">
          <textarea
            placeholder="Ask anything"
            className="w-full bg-transparent border-none outline-none text-white placeholder-gray-500 resize-none text-base"
            value={currentText}
            onChange={(e) => setCurrentText(e.target.value)}
            onKeyDown={handleKeyDown}
            rows={1}
            style={{ minHeight: '24px', maxHeight: '200px' }}
          />
        </div>

        {/* Bottom Row - Tools and Submit */}
        <div className="flex items-center justify-between">
          {/* Left Side - Tools (dev only) */}
          <div className={`${isDev ? 'flex' : 'hidden'} items-center gap-2`}>
            {/* Attachment Button */}
            <button className="p-2 rounded-lg hover:bg-dark-card-hover transition-colors text-gray-400 hover:text-gray-300">
              <Paperclip size={18} />
            </button>

            {/* Deep Search Pill */}
            <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-dark-border hover:bg-dark-card-hover transition-colors">
              <Globe size={14} className="text-accent-teal" />
              <span className="text-sm text-gray-300">Deep Search</span>
            </button>

            {/* Reason Pill */}
            <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-dark-border hover:bg-dark-card-hover transition-colors">
              <Zap size={14} className="text-accent-gold" />
              <span className="text-sm text-gray-300">Reason</span>
            </button>

            {/* More Options */}
            <button className="p-2 rounded-lg hover:bg-dark-card-hover transition-colors text-gray-400 hover:text-gray-300">
              <MoreHorizontal size={18} />
            </button>
          </div>

          {/* Right Side - Submit Button */}
          <button
            onClick={handleButtonClick}
            disabled={!currentText.trim()}
            className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-200 ${
              currentText.trim()
                ? 'bg-accent-teal hover:opacity-90 cursor-pointer'
                : 'bg-dark-card-hover border border-dark-border cursor-not-allowed'
            }`}
          >
            <ArrowUp
              size={20}
              className={currentText.trim() ? 'text-black' : 'text-gray-500'}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntellachatInput;
